import { Fragment, useContext, useState } from 'react';
import axios from 'axios';

import ZoomAPI from 'utils/api/zoom';

import { ZoomRegistrationSuccess, ZoomWebinarOccurrence } from 'types/zoom';

import WebinarRegistrationContext from 'components/content-blocks/webinar-registration/partials/webinar-registration-context';
import SignupResponseError from 'components/modal/signup-response-error';

import WebinarForm, { WebinarFormValues } from './webinar';

type Props = {
  hideInputLabels?: true
  occurrences?: ZoomWebinarOccurrence[]
  onRegistrationSuccess?: (registration: ZoomRegistrationSuccess, occurrenceId?: string | null) => void
  prefilledValues?: Partial<WebinarFormValues>
  submitButtonClassName?: string
  submitButtonText: string
  view?: string,
  webinarId: number
}
const ZoomWebinarSignUpForm = (props:Props) => {
  const onlyAvailableOccurrences: undefined | any[] = props.occurrences && props.occurrences.filter(occurance => occurance.status !== 'deleted');
  const webinarRegistrationContext = useContext(WebinarRegistrationContext);
  const [responseNumber, setResponseNumber] = useState(0);

  const submitRegistration = async (data: WebinarFormValues): Promise<void> => {
    if (webinarRegistrationContext && webinarRegistrationContext.mockRegistration) {
      if (props.onRegistrationSuccess) {
        props.onRegistrationSuccess(
          {} as ZoomRegistrationSuccess,
          data.hasOccurrences && data.occurrence ? data.occurrence : undefined
        );
      }
    } else {
      try {
        const [firstName, ...restOfName] = data.fullName.split(' ');
        const lastName = restOfName.join(' ');
        const registrationResponse = await ZoomAPI.RegisterForWebinar({
          occurrence: data.hasOccurrences && data.occurrence ? data.occurrence : undefined,
          
          registrant: {
            firstName,
            lastName,
            email: data.emailAddress,
            companyName: data.companyName ?? null,
          },
          webinarId: props.webinarId,
        });

        if (props.onRegistrationSuccess) {
          props.onRegistrationSuccess(registrationResponse, data.occurrence);
        }
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          setResponseNumber(e.response.data.code);
        }
      }
    }
  };

  return (
    <Fragment>
      {!!responseNumber && <SignupResponseError
        className='is-block'
        closeErrResponse={ () => setResponseNumber(0) }
        responseNumber={ responseNumber }
      />}
      <div className="event-registration-form-container">
        <WebinarForm
          hideInputLabels={ props.hideInputLabels }
          occurrences={ onlyAvailableOccurrences
            ? onlyAvailableOccurrences.map(occurrence => ({ date: occurrence.startTime, key: occurrence.id }))
            : undefined
          }
          onSubmit={ submitRegistration }
          prefilledValues={ props.prefilledValues }
          submitButtonClassName={ props.submitButtonClassName }
          submitText={ props.submitButtonText }
        />
      </div>
    </Fragment>
  );
};

export default ZoomWebinarSignUpForm;
